export const environment = {
  production: true,
  apiUrl: '/api',
  authUrl: '/authapi',
  webUrl: '',
};
